import { $, $$ } from '@3pc/dom';
import { ClickRedirect } from '@3pc/click-redirect';

const teaserImages = $$('.quote-teaser');

if (teaserImages.length) {
  teaserImages.forEach(teaserImage => {
    // Get references to the source and target elements
    const sourceElement = $('.quote-teaser__picture', teaserImage);
    const targetElement = $('.quote-teaser__button', teaserImage);

    if (!sourceElement || !targetElement) {
      return;
    }

    // Define configuration options
    const config = {
      preventDefault: false, // Prevent the default click behavior
    };

    // Create a ClickRedirect instance
    const clickRedirect = new ClickRedirect(
      sourceElement,
      targetElement,
      config
    );

    // Activate the ClickRedirect (add event listeners)
    clickRedirect.activate();
  });
}
